<template>
  <el-dialog
    title="隐私政策"
    :visible.sync="rechargeProtocolDV"
    width="700px"
    :before-close="closeRechargeProtocol"
    :close-on-click-modal="false"
    class="recharge-protocol-DV"
  >
    <div class="recharge-protocol-content">
      <h1>充值使用协议</h1>
      <h2>尊敬的用户：</h2>
      <p>
        在订购使用快现形(下称“本产品”)查询服务之前，本产品特提醒您注意且您应当审慎阅读、充分理解并严格遵守以下条款：
      </p>
      <p>
        当您在本产品上充值成功后，即表示您已接受《充值使用协议》(下称“本协议”)所述的条款和条件，同意受本协议约束。
      </p>
      <p>
        无论是否实际阅读本协议，您通过网络页面点击充值成功后，均表示您与本产品已就本协议达成一致并同意接受本协议的全部约定内容。如果您不同意本协议的任意内容，或者无法准确理解本协议的内容，请不要同意本协议或使用本协议项下的服务。否则，表示您已接受了以下所述的条款和条件，同意受本协议约束。
      </p>
      <p>
        如果您不同意接受、不能充分理解本协议全部的条款和条件，那么您不应当充值使用本产品或进行任何后续操作。
      </p>
      <h2>第一条、服务内容</h2>
      <p>
        本产品将查询功能提供给您使用，本产品同时提供相关的售前、售中咨询服务。
      </p>
      <h2>第二条、服务费用</h2>
      <p>
        1、本产品将根据不同服务种类收取费用，具体费用标准以网站页面展示为准。
      </p>
      <p>
        2、本产品有权根据经营需要随时变更费用标准，并提前在网站上公示，如您不同意变更后的费用标准应立即停止使用，继续使用将视为同意并接受变更后费用标准。
      </p>
      <p>
        3、本服务的任何免费试用或免费功能和服务不应视为本产品放弃后续收费的权利。本产品有权提前以公告形式通知您收费标准，若您继续使用则需按本产品公布的收费标准支付费用。
      </p>
      <h2>第三条、您的权利和义务</h2>
      <p>
        1、您应当具备使用本服务的相关资质及能力，并保证不违反任何有约束力的法律文件。
      </p>
      <p>
        2、您自行负责内容的创作、开发、编辑、加工、修改、测试、运营及维护等，并且自行承担相应的责任和成本。
      </p>
      <p>
        3、您在使用本产品的服务时，必须遵守中华人民共和国相关法律法规的规定，您承诺将不会利用本服务进行任何违法或不正当的活动，否则本产品有权停止向您提供服务。包括但不限于：
      </p>
      <p>* 反对宪法所确定的基本原则的；</p>
      <p>* 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
      <p>* 损害国家荣誉和利益的；</p>
      <p>* 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
      <p>* 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
      <p>* 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
      <p>* 侮辱或者诽谤他人，侵害他人合法权益的；</p>
      <p>* 未经他人同意传递商业等信息；</p>
      <p>* 从事欺诈或诈骗行为的；</p>
      <p>* 含有法律、行政法规禁止的其他内容的；</p>
      <p>* 本产品认为属于不正当的活动。</p>
      <p>
        4、您不得将本协议约定的服务等全部或部分出售或进行任何利益交换行为，也不得向任何第三方转借、转租或转授权等。
      </p>
      <p>
        5、您的运营需要收集用户数据的，必须事先获得用户的授权，并应当向用户提供隐私保护政策。
      </p>
      <p>
        6、您应当采取有效措施，防止黑客攻击、盗用密码、非法调用页面等危害通信业务信息安全的非法行为。您应妥善保管使用本服务的接口、账号密码并保证自用终端和网络的安全性，使用账号密码从事的一切行为均视为您的行为，因账号密码丢失或被盗以及网络不安全产生的后果由您自行承担。
      </p>
      <p>
        7、您对自己在使用本产品服务过程中的行为及与客户之间的权利义务承担法律责任。本产品不参与您的运营活动。您自主开发、独立运营，您应依法进行运营活动并独立承担相应的法律责任。
      </p>
      <h2>第四条、本产品的权利和义务</h2>
      <p>
        1、本产品如遇网络或系统维护或升级，需要暂停服务或要求您做出配合的，应当提前告知您。
      </p>
      <p>
        2、本产品有权对网站进行修改、升级等各项操作，并有权制定并修改服务内容及服务规范，规范一经发布在本产品及其关联公司网站上即构成本协议的一部分，您应当予以遵守，否则您应当停止使用本服务，本协议自动终止。
      </p>
      <p>
        3、本产品有权为预防、发现和调查欺诈、危害安全、非法或违反与您或其关联公司协议、政策或规则的行为对您服务进行检查监督。本产品有权根据最终用户或第三方的投诉以及本产品对您服务的监督检查，自行决定您及其客户是否利用本服务从事不正当活动，并以此中止或终止向您提供服务。
      </p>
      <p>
        4、本产品有权根据中国法律法规的调整、行政执法机关的命令和社会伦理道德的变化调整本产品服务的标准。
      </p>
      <p>
        5、本产品有权在必要时变更部分或全部的服务功能，如功能变更可能引起日常服务的中断或终止，本产品应当在变更前事先通知您，并尽快完成基本功能的修复。您可以选择继续使用调整后的服务功能，或终止使用本产品服务。
      </p>
      <p>
        6、本产品有权在会员到期后，将根据页面显示会员费用按月自动扣除会员费用，如遇余额不足一个月将等比例扣除会员费用延长会员时长。如您不同意自动扣除，请自动联系在线客户经理申请提取积分。
      </p>
      <p>
        7、您的应用及您所从事的经营业务不得对本产品及其关联公司的利益构成任何现实或潜在的损害或冲突，否则本产品有权立即通知您并终止本产品向您提供的所有服务，而无需承担任何法律责任和费用补偿，同时本产品保留追究您相应责任的权利。
      </p>
      <h2>第五条、使用规范</h2>
      <p>
        1、您应快速响应、积极配合本产品，处理关于您申诉，在6个小时内按本产品规定的格式给予正式回复。
      </p>
      <p>
        2、您不得超出本协议范围使用服务，不得直接或变相向第三方转租转售本产品查询服务，为第三方提供查询服务，不得将本协议全部或任何一部分转让或出借给其他第三方使用。
      </p>
      <p>
        3、本产品有权对您查询进行监督、审核和监测，一经发现您行为违反法律规定或本协议约定的信息，本产品有权立即停止提供服务，并有权视情节轻重要求您限期整改、暂停业务直至单方面解除合作协议。一旦发现您使用本服务的行为违反法律规定或本协议约定行为，本产品有权根据您在使用本产品服务过程发生的违约情况以及给本产品造成的损失，要求您赔偿全部损失、停止服务或解除协议。
      </p>
      <h2>第六条、违约责任</h2>
      <p>
        1、任何一方未履行本协议项下的任何一项条款均被视为违约。违约方应按照本协议的相关约定，依法承担相应违约责任。
      </p>
      <p>
        2、除本协议另有约定外，任何一方违反其于本协议项下的陈述、承诺、保证或义务，而使另一方遭受任何诉讼、纠纷、索赔、处罚等的，违约方应负责解决，使另一方发生任何费用、额外责任或遭受经济损失的，应当负责赔偿。如一方发生违约行为，守约方可以书面通知方式要求违约方在指定的时限内停止违约行为，要求其消除影响。如违约方未能按时停止违约行为，则守约方有权立即终止本协议。
      </p>
      <p>
        3、您违反本协议条款，本产品有权根据情节，对您实施警告、限制服务、中止或终止服务等措施。
      </p>
      <p>
        4、您违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求、损失或纠纷，且该等纠纷解决的结果最终导致本产品承担了任何责任，您同意赔偿本产品及其关联公司和合作公司，并使之免受损害。
      </p>
      <h2>第七条、争议解决</h2>
      <p>
        1、如对本产品提供的查询服务存在异议，需在使用查询服务之日起一个月内联系在线客户经理提出申请。本产品客服部门受理后，将安排相应客服人员跟进处理，并于客服部门受理之日起（即收到申请之日起）7个工作日内向反馈处理结果。
      </p>
      <p>
        2、本协议之履行、解释，以及与本协议有关的争议，均应依照中华人民共和国法律、行政法规等法律法规予以处理，并受本产品所在地人民法院管辖。
      </p>
      <h2>第八条、其他</h2>
      <p>
        如对本协议有任何变更，本产品将以网站公示的方式进行公告，而不再对用户进行单独通知。如您继续使用本产品的查询服务，视为您对修改后的协议无异议、同意遵守且受其约束。
      </p>
    </div>
    <span slot="footer" class="dialog-footer"> </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'rechargeProtocol',
  components: {},
  props: {
    rechargeProtocolDV: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() {

  },
  methods: {
    closeRechargeProtocol() {
      this.$emit('closeRechargeProtocol')
    }
  }
}
</script>

<style scoped lang="scss">
.recharge-protocol-DV {
  .recharge-protocol-content {
    height: 480px;
    overflow-y: scroll;
    line-height: 28px;
    font-size: 16px;
    h1,
    h2 {
      padding: 8px 0;
    }
  }
  ::v-deep.el-dialog__body {
    padding-top: 8px;
  }
}
</style>
